import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { Snackbar, UpdateClient } from "@/components/index";
// Entities
import { Company } from "@/entities/index";

@Component({
  components: {
    UpdateClient,
    Snackbar,
  },
})
export default class Clients extends Vue {
  clients: Company[] = [];

  myClientId = 0;
  selectedClient = {};

  updateClientForm = false;

  headersClientTable = [
    {
      text: "Nom du client",
      align: "start",
      value: "name",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Code logistique",
      value: "codeLogistic",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Langue",
      value: "lang",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Step00 integré",
      value: "integrateStepZero",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Numéro de contenant activé ?",
      value: "optionPalette",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Transport by Tempo ?",
      value: "transportByTempo",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Page désactivée",
      value: "disabledRoute",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Modifier",
      value: "updateClient",
      class: "indigo--text text--darken-4",
      sortable: false,
    },
  ];

  langList = [
    { text: "Français", value: "fr" },
    { text: "Anglais", value: "en" },
  ];

  async allClients(): Promise<void> {
    this.clients = (await axios.get(`/api/companies`)).data as Company[];
  }

  handleEditClient(item: Company) {
    this.myClientId = item.id;
    this.selectedClient = {
      name: item.name,
      codeLogistic: item.codeLogistic,
      disabledRoute: item.disabledRoute,
      image: item.image,
      integrateStepZero: item.integrateStepZero,
      transportByTempo: item.transportByTempo,
      optionPalette: item.optionPalette,
    };
    this.updateClientForm = true;
  }

  handleUpdateClient(updateClient: any): void {
    axios
      .put(`/api/companies/${this.myClientId}`, {
        codeLogistic: updateClient.codeLogistic,
        disabledRoute: updateClient.disabledRoute,
        image: updateClient.image,
        integrateStepZero: updateClient.integrateStepZero,
        transportByTempo: updateClient.transportByTempo,
        optionPalette: updateClient.optionPalette,
      })
      .then(() => {
        this.updateClientForm = false;
        this.myClientId = 0;
        this.showSnackbarUpdateClient();
        this.allClients();
      })
      .catch(() => {});
  }

  mounted(): void {
    this.allClients();
  }

  // ========== OTHER METHODS ========== //

  colorRow(item: Company): any {
    const position = this.clients.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  showSnackbarUpdateClient(): void {
    const snackbarUpdateClient = this.$refs.snackbarUpdateClient as Snackbar;
    snackbarUpdateClient.show();
  }
}
